<template>
  <sidebar-menu :collapsed=stateCollapsed @toggle-collapse="onToggleCollapse"
                :menu="menu">
    <div slot="header" style="background-color: #00b0ff"><p></p></div>
    <div slot="footer" style="background-color: #00b0ff"><p></p></div>
    <span slot="toggle-icon"><mdb-icon icon="arrows-alt-h"/></span>

  </sidebar-menu>
</template>

<script>
    import {eventBus} from '../main'
    import {mdbIcon} from 'mdbvue';

    const separator = {
        template: `<hr style="border-color: red; margin-left: 200px;">`
    };
    const user_menu = [
        {
            href: "/logout",
            title: "logout",
            icon: "fa fa-user"
        },
        {
            href: "/linkedin/dashboard",
            title: "User Dashboard",
            icon: "fa fa-user"
        },
        {
            href: "/linkedin/profile",
            title: "profile",
            icon: "fa fa-user"
        },
        {
            href: "/linkedin/organic-growth",
            title: "Organic growth",
            icon: "fa fa-chart-area"
        },
        {

            title: 'Sales Navigator',
            icon: 'fa fa-chart-area',
            child: [
                {
                    href: "/linkedin/sales/set-user-configuration",
                    title: "Set new configuration",
                    icon: "fa fa-chart-area"
                }, {
                    href: "/linkedin/sales/get-user-config",
                    title: "Existing configuration",
                    icon: "fa fa-chart-area"
                }, {
                    href: "/linkedin/sales/get-user-report",
                    title: "Report per day",
                    icon: "fa fa-chart-area"
                }
            ]
        }
    ];
    const admin_menu = user_menu.concat([
        {

            title: 'Classic Linkedin',
            icon: 'fa fa-chart-area',
            child: [
                {
                    href: "/linkedin/set-user-configuration",
                    title: "Set new configuration",
                    icon: "fa fa-chart-area"
                },

                {
                    href: "/linkedin/get-user-config",
                    title: "Existing configuration",
                    icon: "fa fa-chart-area"
                },
                {
                    href: "/linkedin/get-user-report",
                    title: "Report per day",
                    icon: "fa fa-chart-area"
                }
            ]
        },
        {
            href: "/linkedin/admin_panel",
            title: "Admin Panel",
            icon: "fa fa-chart-area"
        },

    ]);
    const full_bar = user_menu.concat([
        {

            title: 'Classic Linkedin',
            icon: 'fa fa-chart-area',
            child: [
                {
                    href: "/linkedin/set-user-configuration",
                    title: "Set new configuration",
                    icon: "fa fa-chart-area"
                },

                {
                    href: "/linkedin/get-user-config",
                    title: "Existing configuration",
                    icon: "fa fa-chart-area"
                },
                {
                    href: "/linkedin/get-user-report",
                    title: "Report per day",
                    icon: "fa fa-chart-area"
                }
            ]
        },
    ])
    export default {
        name: "NavBarComponent",
        components: {
            eventBus,
            mdbIcon
        },
        data() {
            return {
                user: '',
                menu: [],
                stateCollapsed: false,
            };
        },

        created() {
            this.user = this.$store.getters.getStateLinkedin
            if (this.user.role === 'admin') {
                this.menu = admin_menu
            } else if (this.user.referrer === 'YSY') {
                this.menu = full_bar
            } else {
                this.menu = user_menu
            }
        },
        methods: {
            onToggleCollapse(collapsed) {

                console.log(collapsed);
                this.stateCollapsed = collapsed;
                eventBus.$emit('onToggleCollapse', collapsed);
            }
        }

    };
</script>

<style scoped>
  .v-sidebar-menu {
    /*background-color: green;*/
  }

  @media (max-width: 1200px) {
    .v-sidebar-menu {
      background-color: darkblue;
      width: 250px;
    }
  }

  @media (max-width: 720px) {
    .v-sidebar-menu {
      width: 50px;
    }
  }
</style>
